<template>
  <main class="container py-5" style="max-width: 600px">
    <h1>Activer cet appareil</h1>
    <p>Effectuez cette opération avec votre administrateur.</p>
    <p v-if="error" role="alert" class="text-danger">{{ error }}</p>
    <button v-if="!code" class="btn btn-primary" :disabled="busy" @click="start">Afficher ma demande</button>
    <section v-else>
      <p>Comparez ce code avec celui affiché chez l’administrateur :</p>
      <p class="h2 text-monospace">{{ code }}</p>
      <p>Cette demande expire cinq minutes après sa création.</p>
      <p v-if="!approved">En attente de son autorisation…</p>
      <button v-else class="btn btn-primary" :disabled="busy" @click="register">Créer ma clé d’accès</button>
      <button class="btn btn-link" :disabled="busy" @click="start">Recommencer</button>
    </section>
    <p class="mt-4"><router-link to="/login">Retour à la connexion</router-link></p>
  </main>
</template>
<script>
import {authRequest, usePasskey} from '../services/AuthService';
export default {
  data: () => ({code: '', approved: false, busy: false, error: '', timer: null, stopped: false}),
  beforeDestroy() { this.stopped = true; clearTimeout(this.timer); },
  methods: {
    async start() {
      clearTimeout(this.timer);
      this.busy = true;
      this.error = '';
      this.approved = false;
      try {
        this.code = (await authRequest('/enrollment/start', {})).code;
        this.timer = setTimeout(this.check, 3000);
      } catch (error) { this.error = error.message; }
      finally { this.busy = false; }
    },
    async check() {
      try {
        this.approved = (await authRequest('/enrollment/status')).approved;
        if (!this.approved && !this.stopped) this.timer = setTimeout(this.check, 3000);
      } catch (error) { this.error = error.message; }
    },
    async register() {
      this.busy = true;
      this.error = '';
      try {
        await usePasskey(true);
        await this.$router.replace('/');
      } catch (error) { this.error = error.message; }
      finally { this.busy = false; }
    }
  }
};
</script>
